import { ReactComponent as Icon } from "../images/icon-down.svg";

const DownloadPdf  = ({ size = "120", color = "#5EC394" }) => {
  return (
    <>
      <Icon width={size} height={size} fill={color} />
    </>
  );
};
export default DownloadPdf;
